import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

declareVconsoleComponent('home24StorageCleanButton', () => import('./Home24StorageCleanButton.vue'), 'home24:storage:clean:button');
declareVconsoleComponent('gridTable', () => import('./GridTable.vue'), 'grid:table');